import React from "react";
import { Route, Switch } from "react-router-dom";
import * as Section from "@repoflow/components/section";
import BlogCollectionPublicSchema from "@common/schema/blog-collection/public";
import * as ListRoute from "./list";
import * as NewRoute from "./new";
import * as CollectionRoute from "./collection";

const LocalProvider = ({ match: { params }, children: Children }) => {
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/collection`;
  const basepath = `${parentBasepath}/collection`;

  return (
    <Section.Provider
      schema={BlogCollectionPublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          {/* Before `/:collectionId`, which would otherwise match the literal. */}
          <Route path={`${basepath}/new`} component={NewRoute.Content} />
          <Route path={`${basepath}/:collectionId`} component={CollectionRoute.Content} />
          <Route path={`${basepath}`} component={ListRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/new`} component={NewRoute.Indice} />
          <Route path={`${basepath}/:collectionId`} component={CollectionRoute.Indice} />
          <Route path={`${basepath}`} component={ListRoute.Indice} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => null;
